import { render, staticRenderFns } from "./OutlineColor.vue?vue&type=template&id=2b6b7705"
import script from "./OutlineColor.vue?vue&type=script&lang=js"
export * from "./OutlineColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports